export default state => state.arvato.availablePaymentOptionsList;
